import React, { useState } from 'react';
import capitalise from '../../utils/capitalise';
import { useMediaQuery } from 'react-responsive';
import '../TopCabsRoutes/TopCabsRoutes.css';
import { AppContextConsumer } from '../../AppContext';
import { getAppEnv } from '../../../config/env';
import queryString from 'query-string';
import { setDateAsDatePlusN, setPickupTime } from '../../utils/timeUtils';
import { CabData, CarTypeInfoData } from '../../pages/runtime-typechecker';
import BPG from '../BPG/BPG';
import { CASE_CAB_CARD } from '../../constants/omniture';
import OverLay from '../BPG/Overlay';
import '../../components/RouteCabs/RouteCabs.css';
import {
  MINIBUS,
  ROUTE_CARTYPE,
  TEMPO_TRAVELLER
} from '../../constants/miscellaneousConstants';
import { isWebView } from '../../utils/commonUtils';
const isSSR = () => typeof window === 'undefined';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

type RouteCarTypeCabs = {
  templateType?: string;
  carTypeName: string;
  data: CabData[];
  seoUrl: string | null | undefined;
  sourceCityName: string;
  destinationCityName: string;
  carTypeInfo?: CarTypeInfoData;
  noOfListings?: number;
  showCityNameOnCabCard?: boolean;
};

const RouteCarTypeCabs = ({
  templateType = ROUTE_CARTYPE,
  data,
  sourceCityName,
  destinationCityName,
  carTypeInfo,
  carTypeName,
  noOfListings = 10,
  showCityNameOnCabCard = false
}: RouteCarTypeCabs) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const getModelDescriptionString = (description: string) => {
    const descriptionStringMap = {
      'Similar Model': 'or similar',
      'Specific Model': 'specific model'
    };
    return descriptionStringMap[description]
      ? descriptionStringMap[description]
      : description.toLowerCase();
  };
  const getModelNameString = (modelName: string) => {
    if (modelName == 'GENERIC' && carTypeInfo?.vehicleModel) {
      return carTypeInfo?.vehicleModel
        ? carTypeInfo.vehicleModel.replace(' or similar', '')
        : '';
    }
    return capitalise(modelName);
  };
  const [knowMoreDesktop, setKnowMoreDesktop] = useState(false);
  const [selectedCab, setSelectedCab] = useState(-1);
  const redirect = (url: string | undefined, omniUrlArgs: string) => {
    if (!url) return;
    const query = queryString.parseUrl(url).query;
    const fromCity = query['fromCity'];
    const toCity = query['toCity'];
    const rediectionUrl = isWebView()
      ? `${setDateAsDatePlusN(
          `mmyt://react/?page=cabsListing&deeplink=true&to=${toCity}&from=${fromCity}&tripType=OW&startDate=21-08-2020&${omniUrlArgs}${CASE_CAB_CARD}`
        )}`
      : `${setPickupTime(
          setDateAsDatePlusN(url)
        )}&${omniUrlArgs}${CASE_CAB_CARD}`;
    window.location = Object(rediectionUrl);
  };
  return (
    <AppContextConsumer>
      {({ omniUrlArgs, trackTemplateEvent }) => {
        return isMobileDevice ? (
          data &&
            data
              .filter((_, idx) => (isSSR() ? true : idx < noOfListings))
              .map(cabInfo => (
                <section>
                  <a
                    onClick={e => {
                      trackTemplateEvent(
                        `Cab_SEO_${templateType}_${sourceCityName}-${destinationCityName}_${carTypeName}_Book_Click`
                      );
                      e.preventDefault();
                      redirect(cabInfo.redirection_url, omniUrlArgs);
                    }}
                    href={cabInfo.redirection_url}
                  >
                    <div
                      style={{
                        borderBottom: '1px dashed #E7E7E7'
                        // paddingBottom: '10px'
                      }}
                      className={`makeFlex `}
                    >
                      <div className={`appendRight20`}>
                        <img
                          src={cabInfo.image_url || ''}
                          height={'53px'}
                          width={'79px'}
                          alt={`${cabInfo.type} image`}
                        />
                      </div>
                      <div style={{ width: '40%' }} className={` pushDown`}>
                        <div>
                          <span
                            style={{ color: '#00244D' }}
                            className={`font11 lineHeight14 latoItalic `}
                          >
                            {cabInfo.model_description
                              ? capitalise(cabInfo.model_description)
                              : ``}
                          </span>
                        </div>
                        <div className={`appendBottom5`}>
                          <span
                            className={`font16 lineHeight20 blackText latoBold appendBottom5`}
                          >
                            {cabInfo.model_name
                              ? getModelNameString(cabInfo.model_name)
                              : ``}
                          </span>
                        </div>
                        <div
                          className={`font11 lineHeigh14 latoRegular blackText paddingB10`}
                        >
                          <span className={`appendRight5`}>
                            {carTypeInfo?.type || cabInfo.type || ''}
                          </span>
                          <span className={`appendRight5`}>|</span>
                          <span className={`appendRight5`}>
                            {(() => {
                              if (cabInfo?.seat_count)
                                return cabInfo.seat_count;
                              if (carTypeInfo?.seats) return carTypeInfo.seats;
                            })()}{' '}
                            Seats
                          </span>
                          <span className={`appendRight5`}>|</span>
                          <span>AC</span>
                        </div>
                      </div>
                      <div style={{ width: '33%' }} className={`pushRight`}>
                        {showCityNameOnCabCard && (
                          <div className="rentalCityName">
                            Rental Cab in {cabInfo?.cityName}
                          </div>
                        )}
                        <div className={`pushRightBottom`}>
                          {cabInfo.overall_rating ? (
                            <span className={`ratingBox paddingL2 paddingR4`}>
                              <span className={`font10 latoBlack whiteText `}>
                                {cabInfo.overall_rating}
                              </span>
                              <span className={`font10 latoBlack whiteText`}>
                                /5
                              </span>
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                        <div className={`pushRightBottom`}>
                          {cabInfo.rating_count ? (
                            <span className={`font11 lightGreyText paddingT5`}>
                              {cabInfo.rating_count} ratings
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`appendBottom10`}>
                      <span
                        className={`font12 latoBold blackText lineHeight14 `}
                      >
                        Economical car with best variants
                      </span>
                    </div>
                    <div className={`makeFlex appendBottom10`}>
                      <ul
                        style={{ listStyleType: 'disc' }}
                        className={`routeCarTypeInfoList font11 lineHeight14 blackText paddingL16`}
                      >
                        <li>
                          <span>{cabInfo.included_kms} kms </span>
                          <span className={`latoBold`}>included</span>
                        </li>
                        <li>
                          <span className={`latoBold`}>
                            {cabInfo.per_km_charge}/km after{' '}
                          </span>
                          <span>{cabInfo.included_kms} kms</span>
                        </li>
                        <li>
                          <span className={`latoBold`}>
                            {(() => {
                              if (cabInfo?.luggage_count)
                                return cabInfo.luggage_count;
                              if (carTypeInfo?.luggage)
                                return carTypeInfo.luggage;
                            })()}{' '}
                            Luggage{' '}
                          </span>
                          <span>Bags</span>
                        </li>
                        {/* <li>
                            <span  className={`latoBold`}>2017 or newer </span><span>cars</span>
                        </li> */}
                      </ul>
                      <div className={`pushRight appendTop10`}>
                        <div>
                          <div
                            className={
                              cabInfo.strike_off_amount
                                ? `pushRight`
                                : `pushRight2`
                            }
                          >
                            <span
                              className={`font12 strikeOffPrice appendRight5 `}
                            >
                              {cabInfo.strike_off_amount
                                ? `₹${cabInfo.strike_off_amount}`
                                : ``}
                            </span>
                            <span
                              className={`font24 blackText latoSemiBold pushRight`}
                            >
                              ₹{cabInfo.total_amount}
                            </span>
                          </div>
                          <div>
                            <span
                              className={`font10 lineHeight12 pushRightBottom lightGreyText`}
                            >
                              {cabInfo?.tolls_and_taxes_text}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div>
                    {!isSSR() && cabInfo.best_price_guarantee_details ? (
                      <div>
                        <BPG
                          bpgInfo={cabInfo.best_price_guarantee_details}
                          isMobileDevice={true}
                          fromCity={sourceCityName}
                          toCity={destinationCityName}
                        />
                      </div>
                    ) : null}
                  </div>
                </section>
              ))
        ) : (
          <section>
            <table
              style={{
                borderSpacing: '0px 15px',
                border: '1px solid #000',
                width: '100%'
              }}
              className={`noTableBorder`}
            >
              <tbody>
                {data &&
                  data
                    .filter((_, idx) => (isSSR() ? true : idx < noOfListings))
                    .map((cabInfo, idx) => (
                      <tr className={`routeCarTypeCard tableRow`}>
                        <td
                          style={{ width: '170px' }}
                          className={`paddingL20 paddingT16 paddingB75`}
                        >
                          <div>
                            <img
                              src={cabInfo.image_url || ''}
                              height={'90px'}
                              width={
                                carTypeInfo?.type == TEMPO_TRAVELLER ||
                                carTypeInfo?.type == MINIBUS
                                  ? '140px'
                                  : '120px'
                              }
                              alt={`${cabInfo.type} image`}
                            />
                          </div>
                        </td>
                        <td>
                          <div style={{ width: '550px' }}>
                            <div>
                              <span
                                className={`font20 latoBlack lineHeight24 blackText ${
                                  cabInfo.model_name ? `appendRight5` : ``
                                }`}
                              >
                                {cabInfo.model_name
                                  ? getModelNameString(cabInfo.model_name)
                                  : ''}
                              </span>
                              <span
                                className={`latoRegular font14 lightGreyText ${
                                  cabInfo.model_description
                                    ? `appendRight10`
                                    : ``
                                }`}
                              >
                                {cabInfo.model_description
                                  ? getModelDescriptionString(
                                      cabInfo.model_description
                                    )
                                  : ''}
                              </span>
                              {cabInfo.overall_rating ? (
                                <span
                                  className={`ratingBox paddingL2 paddingR4 appendRight5`}
                                >
                                  <span
                                    className={`latoBlack whiteText lineHeight18 font14`}
                                  >
                                    {cabInfo.overall_rating}/
                                  </span>
                                  <span
                                    className={`whiteText lineHeight18 font12`}
                                  >
                                    5
                                  </span>
                                </span>
                              ) : null}
                              {cabInfo.rating_count ? (
                                <span
                                  className={`font12 lineHeight14 lightGreyText`}
                                >
                                  {cabInfo.rating_count} ratings
                                </span>
                              ) : null}
                              {showCityNameOnCabCard && (
                                <span className="rentalCityName">
                                  Rental Cab in {cabInfo?.cityName}
                                </span>
                              )}
                            </div>
                            <div className={`appendBottom30 appendTop10`}>
                              <span
                                className={`latoBold font14 lineHeight18 blackText`}
                              >
                                {carTypeInfo?.type || cabInfo.type || ''}
                                &nbsp;&nbsp;&nbsp;
                              </span>
                              <span>|&nbsp;&nbsp;&nbsp;</span>
                              <span
                                className={`blackText font14 lineHeight18 latoRegular`}
                              >
                                <img
                                  className="appendRight5 lazyload"
                                  width="11px"
                                  height="12px"
                                  alt="seat image"
                                  data-src={`${PUBLIC_URL}/static/public/seat2.png`}
                                ></img>
                                {(() => {
                                  if (cabInfo?.seat_count)
                                    return cabInfo.seat_count;
                                  if (carTypeInfo?.seats)
                                    return carTypeInfo.seats;
                                })()}{' '}
                                Seats&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </span>
                              <span
                                className={`blackText font14 lineHeight18 latoRegular`}
                              >
                                <img
                                  className="appendRight5 lazyload"
                                  width="19px"
                                  height="9px"
                                  alt="seat image"
                                  data-src={`${PUBLIC_URL}/static/public/ac2.png`}
                                ></img>
                                AC &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{' '}
                              </span>
                              <span
                                className={`blackText font14 lineHeight18 latoRegular`}
                              >
                                <img
                                  className="appendRight5 lazyload"
                                  width="15px"
                                  height="15px"
                                  alt="seat image"
                                  data-src={`${PUBLIC_URL}/static/public/bag2.png`}
                                />
                                {(() => {
                                  if (cabInfo?.luggage_count)
                                    return cabInfo.luggage_count;
                                  if (carTypeInfo?.luggage)
                                    return carTypeInfo.luggage;
                                })()}{' '}
                                Luggage Bags
                              </span>
                            </div>
                            <div className={`appendBottom25`}>
                              <div
                                style={{
                                  borderTop: '0.5px solid #C3C3C3',
                                  opacity: '.5'
                                }}
                                className={`paddingT10`}
                              ></div>
                              <div>
                                <span className={`font14 blackText`}>
                                  <span
                                    className={`latoSemiBold  lineHeight20`}
                                  >
                                    {cabInfo.included_kms} kms
                                  </span>{' '}
                                  included
                                </span>{' '}
                                |
                                <span className={`font14 blackText`}>
                                  <span
                                    className={`latoSemiBold  lineHeight20`}
                                  >
                                    {cabInfo.per_km_charge}/km{' '}
                                  </span>
                                  after {cabInfo.included_kms} kms
                                </span>
                                <div
                                  style={{
                                    borderBottom: '0.5px solid #C3C3C3',
                                    opacity: '.5'
                                  }}
                                  className={`paddingB10`}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              width: '180px',
                              marginRight: '30px',
                              marginLeft: 'auto'
                            }}
                          >
                            <div
                              style={{ marginLeft: 'auto' }}
                              className={`pushRightBottom`}
                            >
                              <span
                                className={`strikeOffPrice appendRight5 appendTop5`}
                              >
                                {cabInfo.strike_off_amount
                                  ? `₹${cabInfo.strike_off_amount}`
                                  : ``}
                              </span>
                              <span className={`cabTypePrice`}>
                                {cabInfo.total_amount
                                  ? `₹${cabInfo.total_amount}`
                                  : ``}
                              </span>
                            </div>
                            {cabInfo.best_price_guarantee_details ? (
                              <>
                                <div
                                  className={`latoRegular appendBottom10 pushRightBottom`}
                                >
                                  <span>{cabInfo?.tolls_and_taxes_text}</span>
                                </div>
                                <div
                                  className={`appendBottom5 pushRightBottom`}
                                >
                                  <span
                                    style={{
                                      backgroundColor: '#C1F1DD',
                                      padding: '4px 8px',
                                      color: '#1A7971',
                                      borderRadius: '14.5px',
                                      fontSize: '11px'
                                    }}
                                    className={`latoBlack`}
                                  >
                                    {
                                      cabInfo.best_price_guarantee_details
                                        .header
                                    }
                                  </span>
                                </div>
                                <div
                                  className={`appendBottom15 pushRightBottom`}
                                >
                                  <span
                                    style={{ color: '#1A7971' }}
                                    className={`font12 appendRight3`}
                                  >
                                    {
                                      cabInfo.best_price_guarantee_details
                                        .description
                                    }
                                  </span>
                                  <span
                                    style={{ color: '#008cff' }}
                                    className={`latoBold font12 cursorPointer`}
                                    onClick={() => {
                                      setSelectedCab(idx);
                                      setKnowMoreDesktop(true);
                                    }}
                                  >
                                    {
                                      cabInfo.best_price_guarantee_details
                                        .know_more_label
                                    }
                                  </span>
                                </div>
                                {knowMoreDesktop &&
                                idx === selectedCab &&
                                cabInfo.best_price_guarantee_details
                                  .know_more_details ? (
                                  <OverLay
                                    style={{
                                      marginTop: '-10px',
                                      marginLeft: '-120px'
                                    }}
                                    cancelButton={() => {
                                      setSelectedCab(-1);
                                      setKnowMoreDesktop(false);
                                    }}
                                    knowMoreDetails={
                                      cabInfo.best_price_guarantee_details
                                        .know_more_details
                                    }
                                  />
                                ) : null}
                              </>
                            ) : (
                              <div
                                style={{ marginLeft: 'auto', color: '#6D7278' }}
                                className={`appendBottom60 font14 lineHeight18 pushRightBottom`}
                              >
                                {cabInfo?.tolls_and_taxes_text}
                              </div>
                            )}
                            <div className={`pushRightBottom`}>
                              <a
                                className="viewCabBtn"
                                href={cabInfo.redirection_url}
                                onClick={e => {
                                  trackTemplateEvent(
                                    `Cab_SEO_${templateType}_${sourceCityName}-${destinationCityName}_${carTypeName}_Book_Click`
                                  );
                                  e.preventDefault();
                                  redirect(
                                    cabInfo.redirection_url,
                                    omniUrlArgs
                                  );
                                }}
                              >
                                {' '}
                                BOOK NOW
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </section>
        );
      }}
    </AppContextConsumer>
  );
};

export default RouteCarTypeCabs;
